export function formatProviderName(provider) {
  if (!provider) return "";
  const p = String(provider).toLowerCase().trim();

  const map = {
    "openai": "OpenAI",
    "anthropic": "Anthropic",
    "google": "Google",
    "xai": "xAI",
    "groq": "Groq",
    "perplexity": "Perplexity",
    "openrouter": "OpenRouter",
    "okeybot": "OkeyBot"
  };

  return map[p] || (p.charAt(0).toUpperCase() + p.slice(1));
}

export function formatModelName(provider, modelId, modelsContext) {
  if (!modelsContext || !Array.isArray(modelsContext)) return modelId;

  // Find the provider group
  const providerGroup = modelsContext.find(
    p => p.provider.toLowerCase() === (provider || "").toLowerCase()
  );

  if (!providerGroup?.models) return modelId;

  // Find the specific model
  const model = providerGroup.models.find(m => m.name === modelId);
  return model ? model.displayName : modelId;
}
